module.exports = __webpack_public_path__ + "assets/taboola.a4cde056.svg";